import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type RATING_SIZE = 'large' | 'mid';

@Component({
  selector: 'fl-rating',
  template: `
    <ng-container *ngIf="!simple">
      <div
        class="RatingLabel"
        role="presentation"
        [attr.data-size]="size"
        *ngIf="labelled"
      >
        {{ value | number:'1.1-1' }}
      </div>
      <div
        class="StarsBackground"
        attr.aria-label="Rating of {{value | number:'1.1-1'}}"
        [attr.data-size]="size"
      >
        <div
          role="presentation"
          class="StarsForeground"
          [style.width]="calculateWidth()"
          [attr.data-size]="size"
        ></div>
      </div>
    </ng-container>
    <ng-container *ngIf="simple">
      <div
        class="SimpleStars"
        [attr.data-size]="size"
        attr.aria-label="Rating of {{value | number:'1.1-1'}}"
      ></div>
      <div
        class="SimpleRatingLabel"
        role="presentation"
        [attr.data-size]="size"
      >
        {{ value | number:'1.1-1' }}
      </div>
    </ng-container>
  `,
  styleUrls: ['./rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingComponent {
  // TODO: This component needs to be converted into a series
  // of radio buttons for user input when specified.
  // See T36571 for ticket.

  @Input() value = 0;
  @Input() simple?: false;
  @Input() size: RATING_SIZE = 'mid';
  @Input() labelled?: false;

  maximumRating = 5;

  calculateWidth() {
    const percentage = this.value / this.maximumRating * 100;
    return `${percentage}%`;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/app/@shared/ui/rating/rating.component.ts